export const enum BookingStep {
  ChooseLocation,
  ChooseDateTime,
  ChooseRoom,
  ReviewPrice,
}

export const enum ActionTypes {
  SetHotel = 'Set Hotel',
}

export const enum PriceOptions {
  Hour = 'hour',
  Night = 'night',
  Day = 'day',
}

export interface ISearchQueryParams {
  priceOption: PriceOptions
  from?: string
  to?: string
  hours?: number
  nights?: number
}
